{
  "label": "Шот",
  "labelWithScene": "Шот {{scene}}.{{number}}",
  "labelWithNumber": "Шот {{number}}",
  "transitionShot": "Шот-переход {{number}}",
  "noDescription": "Без описания",
  "draft": {
    "badge": "Черновик 480p",
    "to1080p": "В 1080p",
    "segmentHint": "Текущее видео было черновиком, его можно перегенерировать в 1080p с сохранением композиции.",
    "finalize": "Финализировать",
    "dialogTitle": "Финал черновика",
    "daysLeft": "Доступно ещё {{count}} дн.",
    "regenerateNote": "Сейчас видео перегенерируется из этого черновика в выбранном разрешении. Черновик останется в списке версий.",
    "unavailable": "Черновик сейчас нельзя финализировать.",
    "failed": "Не удалось запустить финал."
  },
  "nav": {
    "prevWithSummary": "Шот {{number}} — {{summary}}",
    "prevNumberOnly": "Шот {{number}}",
    "noPrev": "Нет предыдущего шота",
    "noNext": "Нет следующего шота"
  },
  "panel": {
    "title": "{{base}} — Генерация",
    "editShot": "Редактировать шот",
    "loadFailed": "Не удалось загрузить данные проекта",
    "frameFormat": "Формат кадра",
    "frameFormatHint": "Формат этого шота для новых генераций. В панели шота превью сразу в выбранном формате; сборка проекта идёт в формате проекта. Уже созданные кадры сохраняют исходную пропорцию.",
    "changeFrameFormat": "Сменить формат шота",
    "videoModel": "Модель видео",
    "videoModelHint": "Модель генерации для этого шота. Пустое значение — настройки проекта.",
    "changeVideoModel": "Сменить модель видео",
    "videoResolution": "Разрешение видео",
    "videoResolutionHint": "Разрешение результата для этого шота. Пустое значение — настройки проекта для текущей модели.",
    "changeVideoResolution": "Сменить разрешение",
    "draft": "Черновик",
    "draftOnHint": "Черновик включён. Следующее видео будет черновиком 480p. Нажмите, чтобы сгенерировать обычное.",
    "draftOffHint": "Черновик выключен. Нажмите, чтобы следующее видео было черновиком 480p.",
    "back": "Назад",
    "backTo": "Назад к {{place}}",
    "backToShot": "Назад к шоту",
    "returnPlace": {
      "storyboard": "сториборду",
      "generations": "генерациям",
      "animatics": "аниматикам",
      "library": "библиотеке",
      "assembly": "монтажу",
      "overview": "обзору",
      "canvas": "холсту",
      "studio": "студии",
      "seasons": "сезонам",
      "script": "сценарию",
      "characters": "героям",
      "locations": "локациям",
      "props": "реквизиту",
      "cameras": "камерам",
      "presets": "пресетам",
      "skills": "скиллам"
    }
  },
  "firstGenResolutionConfirm": {
    "title": "Первая генерация видео",
    "message": "Для первой генерации попробуйте {{resolution}} — так быстрее и дешевле. Потом можно перегенерировать в более высоком разрешении.",
    "generateMin": "Сгенерировать {{resolution}}",
    "generateAt": "Сгенерировать в {{resolution}}"
  },
  "videoMissingFrameConfirm": {
    "title": "Опорный кадр ещё не готов",
    "message": "У этого шота ещё нет опорного кадра. Без него модель будет опираться только на промпт и референсные материалы. Продолжить генерацию видео без опорного кадра?",
    "confirm": "Сгенерировать видео без кадра"
  },
  "videoPrevizConfirm": {
    "title": "Превиз не включён",
    "message": "У этого шота есть превиз, но он не будет отправлен в генерацию. Сгенерировать видео с превизом или без него?",
    "with": "Включить превиз",
    "without": "Без превиза"
  },
  "videoAnimaticConfirm": {
    "title": "Аниматик не включён",
    "message": "У этого шота есть аниматик, но он не будет отправлен в генерацию. Сгенерировать видео с аниматиком или без него?",
    "with": "Включить аниматик",
    "without": "Без аниматика"
  },
  "sidebar": {
    "assistant": "Ассистент и промпты",
    "preview": "Промпты",
    "characters": "Герои",
    "location": "Локация",
    "props": "Реквизит",
    "transcription": "Транскрипция",
    "storyboard_versions": "Версии кадров",
    "shooting_board_versions": "Раскадровка",
    "video_versions": "Версии видео",
    "post_production_versions": "Обработка",
    "flow": "Флоу"
  },
  "tabs": {
    "transition": "Переход",
    "storyboard": "Опорный кадр",
    "video": "Видео",
    "shootingBoard": "Раскадровка",
    "animatic": "Аниматик",
    "previz": "Превиз",
    "unseenAfterGeneration": "Новый контент после генерации"
  },
  "previz": {
    "assign": "Сделать превизом шота",
    "replace": "Загрузить",
    "replaceTitle": "Заменить превиз?",
    "replaceMessage": "К шоту уже привязан превиз. Новый превиз заменит текущий (файл останется в библиотеке).",
    "replaceConfirm": "Заменить",
    "pickFromLibrary": "Из библиотеки",
    "record": "Записать превиз",
    "preparingTitle": "Превиз: Сц.{{scene}} шот {{number}}",
    "preparingTitleShort": "Превиз: шот {{number}}",
    "recordHint": "Записать пролёт камеры в 3D-сцене",
    "selectScene": "Выбрать 3D-сцену",
    "createScene": "Создать 3D-сцену",
    "pickerTitle": "Выбор 3D-сцены",
    "pickerSearch": "Поиск 3D-сцен…",
    "pickerClose": "Закрыть",
    "pickerLoading": "Загрузка…",
    "pickerEmpty": "Нет 3D-сцен",
    "pickerNoResults": "Ничего не найдено",
    "pickerUnlocated": "Без локации",
    "defaultSceneName": "Сцена",
    "unlink": "Отвязать",
    "linkFailed": "Не удалось привязать превиз.",
    "pickFailed": "Не удалось сделать превиз шота.",
    "videoMissing": "Видео превиза недоступно.",
    "uploadHint": "Перетащите видео превиза сюда",
    "uploadHintDetail": "или выберите файл (webm/mp4), возьмите видео из библиотеки, либо запишите пролёт в 3D-сцене",
    "uploadButton": "Загрузить файл",
    "send": "Отправить превиз",
    "sendHint": "В генерацию уйдёт превиз шота: пролёт камеры или маска глубины — как выбрано ниже (до {{max}} с).",
    "sendTooLong": "Превиз длиннее лимита видео-референса: {{duration}} с при максимуме {{max}} с.",
    "sendTranscodePending": "Превиз ещё конвертируется в mp4 — генерация дождётся окончания.",
    "sendTranscodeFailed": "Не удалось подготовить mp4 превиза. Пересохраните превиз и попробуйте снова.",
    "noLinked": "К шоту не привязан превиз — добавьте его на вкладке «Превиз».",
    "sendOriginalTitle": "Оригинал",
    "sendOriginalDesc": "Пролёт камеры уйдёт как reference_video: движение, кадрирование и тайминг — из превиза.",
    "sendDepthBwTitle": "Маска глубины (черно-белая)",
    "sendDepthBwDesc": "Использовать черно-белую карту глубины. Яркость показывает расстояние до камеры, а не свет и не стиль.",
    "sendDepthColorTitle": "Маска глубины (цветная)",
    "sendDepthColorDesc": "Использовать цветную карту глубины. Цвет показывает расстояние до камеры, а не свет и не стиль.",
    "depthNeedsGenerate": "Сначала сгенерируйте маску глубины на вкладке «Превиз».",
    "depthGray": "Черно-белая",
    "depthColor": "Цветная",
    "viewClip": "Превиз",
    "viewDepth": "Маска глубины",
    "depthNotGenerated": "Маска глубины ещё не сгенерирована.",
    "depthGenerate": "Сгенерировать",
    "depthGenerating": "Считаем маску глубины…",
    "depthGenerateFailed": "Не удалось запустить расчёт маски глубины.",
    "depthNeedsMp4": "Сначала дождитесь готового mp4 превиза."
  },
  "composerTabs": {
    "frame": "Кадр",
    "video": "Видео",
    "assistant": "Ассистент",
    "transitionEmpty": "У шота-перехода нет промпта кадра"
  },
  "promptTabs": {
    "storyboard": "Промпт опорного кадра",
    "video": "Промпт видео",
    "shooting_board": "Промпт раскадровки",
    "animatic": "Аниматик",
    "previz": "Превиз"
  },
  "player": {
    "timecode": "Таймкод (часы:минуты:секунды:кадры)",
    "toStart": "В начало (Home)",
    "toEnd": "В конец (End)",
    "frameBack": "Кадр назад (←)",
    "frameForward": "Кадр вперёд (→)",
    "play": "Воспроизвести (Space / L)",
    "pause": "Пауза (Space / K)",
    "loop": "Повтор",
    "pip": "Картинка в картинке",
    "pipPreviz": "Превиз",
    "pipAnimatic": "Аниматик",
    "audioScrub": "Звук при перемотке плейхеда",
    "fullscreen": "На весь экран",
    "exitFullscreen": "Выйти из полноэкранного режима",
    "mute": "Без звука",
    "unmute": "Включить звук",
    "volume": "Громкость",
    "shortcutsAria": "Горячие клавиши",
    "shortcutsTitle": "Горячие клавиши",
    "shortcutsPlayback": "Воспроизведение",
    "shortcutsSeek": "Перемотка",
    "shortcutsEdit": "Редактирование",
    "shortcutsView": "Вид",
    "shortcutPlayPause": "Воспроизведение / пауза",
    "shortcutReverse": "Назад (повтор удваивает скорость до 4×)",
    "shortcutPause": "Пауза",
    "shortcutPlayForward": "Вперёд (повтор удваивает скорость до 8×)",
    "shortcutFrameBack": "Кадр назад",
    "shortcutFrameForward": "Кадр вперёд",
    "shortcutSeekBack": "На −1 секунду",
    "shortcutSeekForward": "На +1 секунду",
    "shortcutToStart": "В начало",
    "shortcutToEnd": "В конец"
  },
  "timeline": {
    "saveFailed": "Не удалось сохранить таймлайн",
    "snapping": "Прилипание (выравнивание по краям клипов)",
    "blade": "Разрезать под плейхедом (B)",
    "deleteClip": "Удалить выбранный клип (Del)",
    "shortcutBlade": "Разрезать под плейхедом",
    "shortcutDeleteClip": "Удалить выбранный клип",
    "shortcutRateStretch": "Rate-stretch края клипа (изменение скорости)",
    "shortcutZoom": "Масштаб таймлайна",
    "speed": "Скорость клипа",
    "speedHint": "Скорость воспроизведения выбранного клипа. Alt+drag края клипа меняет скорость без подрезки.",
    "speedReset": "Сбросить до 1x",
    "addTrack": "Добавить дорожку",
    "addVideoTrack": "Видеодорожка (версия шота)",
    "addAnimaticTrack": "Аниматик",
    "addCorrectionTrack": "Корректировка",
    "addAudioTrack": "Аудиодорожка",
    "pickAudioTrack": "Выберите дорожку",
    "emptyAudioTrack": "Пустая дорожка",
    "audioAssetFallback": "Аудио",
    "correctionTrackHint": "Дорожка корректировки",
    "openCorrection": "Открыть корректировку",
    "pickVersion": "Выберите версию шота",
    "pickAnimatic": "Аниматик",
    "animaticVideoWithAudio": "Видео со звуком",
    "animaticVideoOnly": "Только видео",
    "animaticAudioOnly": "Только звук",
    "animaticTrackLabel": "Аниматик",
    "animaticUnavailable": "Нет аниматика",
    "activeVersion": "активная",
    "render": "Рендер",
    "renderHint": "Собрать таймлайн в новую видеоверсию шота",
    "renderStarted": "Рендер запущен",
    "renderFailed": "Не удалось запустить рендер",
    "lipsyncHint": "Липсинк: выделите один видеоклип и один аудиоклип (cmd+клик)",
    "lipsyncStarted": "Липсинк запущен — клипы заморожены до завершения",
    "lipsyncFailed": "Не удалось запустить липсинк",
    "versionAudioLabel": "Аудио версии",
    "versionAudioNamed": "a{{n}}",
    "renameVersion": "Переименовать версию",
    "renameFailed": "Не удалось переименовать версию",
    "customAudioLabel": "Аудио",
    "videoTrackLabel": "Видео",
    "muteTrack": "Заглушить дорожку",
    "unmuteTrack": "Включить дорожку",
    "trackVolume": "Громкость дорожки",
    "volumeOff": "Выкл",
    "hideTrack": "Скрыть слой",
    "showTrack": "Показать слой",
    "dragToReorder": "Перетащите, чтобы изменить порядок дорожек",
    "detachAudio": "Отделить аудио в отдельную дорожку",
    "audioDetached": "Аудио отделено",
    "deleteTrack": "Удалить дорожку",
    "record": "Записать с микрофона",
    "tts": "Текст в речь",
    "uploadAudio": "Загрузить аудиофайл",
    "audioInput": "Аудиовход",
    "defaultMicrophone": "Микрофон по умолчанию",
    "defaultInputNamed": "По умолчанию — {{name}}",
    "microphoneN": "Микрофон {{n}}",
    "systemAudio": "Звук вкладки или экрана",
    "systemAudioMissing": "Звук не захвачен: включите «Поделиться звуком» в диалоге выбора (работает в Chrome и Edge)",
    "systemAudioCancelled": "Выбор источника отменён",
    "microphoneUnavailable": "Выбранный микрофон недоступен — пишем со входа по умолчанию",
    "keepOriginalVoice": "Не менять голос",
    "voiceChangeElevenLabsOnly": "Замена голоса доступна только для голосов ElevenLabs.",
    "voice": "Голос",
    "playVideoWithRecording": "Запустить видео вместе с началом записи",
    "startRecording": "Начать запись",
    "stopRecording": "Остановить запись",
    "rec": "REC",
    "cancel": "Отмена",
    "recordAgain": "Записать заново",
    "recordTrackLocked": "На дорожке есть клип, замороженный липсинком. Дождитесь окончания.",
    "recordingTooShort": "Запись слишком короткая",
    "recordingPermissionDenied": "Нет доступа к микрофону",
    "ttsPlaceholder": "Текст для озвучки…",
    "generate": "Сгенерировать",
    "assetFailed": "Не удалось обработать аудио",
    "processingAudio": "Обработка аудио…"
  },
  "common": {
    "provider": "Провайдер:",
    "loading": "Загрузка…",
    "loadingPrompts": "Загрузка промптов…",
    "loadingPrompt": "Загрузка промпта…",
    "loadingFrameData": "Загрузка данных кадра…",
    "networkUnavailable": "Сеть недоступна.",
    "sessionExpired": "Сессия устарела: обновите страницу.",
    "sessionExpiredRetry": "Сессия устарела: обновите страницу и попробуйте снова.",
    "saved": "Сохранено",
    "saveFailed": "Не удалось сохранить",
    "retry": "Повторить",
    "upload": "Загрузить",
    "uploadOwn": "Загрузить свою",
    "close": "Закрыть",
    "cancel": "Отмена",
    "save": "Сохранить",
    "saving": "Сохранение…",
    "savedState": "Сохранено",
    "saveErrorRetry": "Ошибка, повторить",
    "submitting": "Отправка…",
    "improving": "Улучшение…",
    "improve": "Улучшить",
    "edit": "Редактировать",
    "copy": "Скопировать",
    "downloadOriginal": "Скачать оригинал",
    "downloadVideo": "Скачать видео",
    "regenerate": "Сгенерировать заново",
    "correct": "Корректировать",
    "correctVideo": "Корректировать видео",
    "generateVideo": "Сгенерировать видео",
    "generateDraft": "Сгенерировать черновик",
    "generateFrame": "Сгенерировать кадр",
    "generateShootingBoard": "Сгенерировать раскадровку",
    "generateFromVideoPrompt": "Из текста видео-промпта (провайдер изображений проекта)",
    "noFrame": "Нет кадра",
    "first": "Первый",
    "last": "Последний",
    "poster": "Постер",
    "frameNotReady": "Кадр ещё не готов",
    "showShot": "Показать шот",
    "hideShot": "Скрыть шот",
    "delete": "Удалить",
    "deleteConfirm": "Удалить безвозвратно?",
    "yesDelete": "Да, удалить",
    "shotShown": "Шот показан",
    "shotHidden": "Шот скрыт",
    "shotDeleted": "Шот удалён",
    "originalCopied": "Оригинал скопирован в буфер обмена",
    "copyImageFailed": "Не удалось скопировать изображение",
    "copyClipboardFailed": "Не удалось скопировать в буфер",
    "panelCount": "Число панелей",
    "multishot": "Мультишот",
    "duration": "Длительность",
    "durationAuto": "Авто",
    "videoDuration": "Длительность видео",
    "extractFrames": "Вырезать кадры",
    "framesNotExtracted": "Кадры не извлечены",
    "videoFrames": "Кадры видео",
    "unlinkSegment": "Открепить",
    "downloadSegment": "Скачать сегмент",
    "downloadSegmentPreparing": "Готовим сегмент…",
    "downloadSegmentFailed": "Не удалось подготовить сегмент.",
    "segmentPosition": "Сегмент #{{position}}",
    "referenceClipNotCreated": "Референс-клип ещё не создан",
    "pickAnimaticFromLibrary": "Выбрать в библиотеке",
    "assignAnimaticSegment": "Сделать аниматиком шота",
    "linkSegmentFailed": "Не удалось сделать аниматик шота",
    "uploadAnimaticHint": "Загрузите аниматик сюда или выберите видео в библиотеке",
    "uploadAnimaticHintDetailBefore": "Файл, загруженный здесь, останется в этом шоте и не попадёт на ленту серии. Можно также привязать сегмент из раздела ",
    "uploadAnimaticHintDetailLink": "«Аниматики»",
    "uploadAnimaticHintDetailAfter": ".",
    "noAnimaticSegment": "Нет привязанного сегмента аниматика к этому шоту.",
    "sliceFromAnimatic": "Нарезать из аниматика",
    "updateFromAnimatic": "Обновить из аниматика",
    "buildStripToShootingBoard": "Собрать полосу в раскадровку шота",
    "animaticStripHint": "Полоса из кадров сегмента аниматика (как у MP4-референса). Можно пересобрать с другим числом панелей.",
    "animaticFramesHint": "Кадры из окна сегмента аниматика (как у MP4-референса), равномерно по времени.",
    "resetToTemplate": "К шаблону",
    "resetStoryboardConfirm": "Сбросить промпты кадра к серверным шаблонам?",
    "resetVideoConfirm": "Сбросить промпты видео к серверным шаблонам?",
    "toTemplate": "К шаблону",
    "insertTemplate": "Подставить шаблон",
    "insertTemplateTitle": "Вставить серверный шаблон (системный блок видео + кадр + движение)",
    "matchesTemplate": "Текст уже совпадает с шаблоном",
    "promptHistory": "История промптов",
    "improvePrompt": "Улучшить промпт",
    "systemPrompt": "Системный промпт",
    "systemPromptVideo": "Системный промпт видео",
    "systemPromptShootingBoard": "Системный промпт раскадровки",
    "framePrompt": "Промпт кадра",
    "videoPrompt": "Промпт видео",
    "shootingBoardPrompt": "Промпт раскадровки",
    "shootingBoardPanelCountLabel": "Количество панелей",
    "shootingBoardPanelCount_one": "{{count}} панель",
    "shootingBoardPanelCount_few": "{{count}} панели",
    "shootingBoardPanelCount_many": "{{count}} панелей",
    "shootingBoardPanelCount_other": "{{count}} панели",
    "shootingBoardAutoHint": "Промпт генерации раскадровки собирается автоматически на сервере и не редактируется.",
    "addLocationDescription": "Добавить описание локации",
    "addHeroDescription": "Добавить описание героев",
    "addPropsDescription": "Добавить описание реквизита",
    "generationSettings": "Настройки",
    "extraReferences": "Доп. референсы при генерации кадра",
    "sendCurrentAsReference": "Передать текущий вариант как референс",
    "sendCurrentAsReferenceHint": "Текущее превью кадра подставится в запрос вместе с остальными референсами (после героев, локации и своих @reference_n).",
    "addAnimaticFrameReference": "Добавить кадр из аниматика как референсный",
    "addAnimaticFrameReferenceHint": "К выбранному кадру добавится отдельный системный промпт: чёрно-белый скетч — только композиция.",
    "activeVideoMarkers": "Метки активной версии видео (таймкоды)",
    "sendAnimaticSegment": "Отправить сегмент аниматика",
    "sendAnimaticSegmentHint": "В запрос добавится нарезанный фрагмент по границам сегмента (до {{max}} с) и блок промпта про камеру и монтаж. Нарезка выполняется в фоне.",
    "sendAnimaticSegmentHintShort": "Видео-референс для генерации; нарезка в фоне после сохранения.",
    "sendAnimaticSegmentTooLong": "Сегмент {{duration}} с. Будет подрезан до {{max}} с — максимум видео-референса текущей модели.",
    "sendAnimaticSegmentTooShort": "Сегмент {{duration}} с. Будет продлён последним кадром (статика) до {{min}} с — минимум видео-референса текущей модели.",
    "sendShootingBoardReference": "Отправить раскадровку как референс",
    "videoConsiderScale": "Учитывать масштаб героев",
    "videoConsiderScaleHintBefore": "Прикрепить ",
    "videoConsiderScaleHintBeforeCompact": "Прикрепить ",
    "videoConsiderScaleHintLink": "лист размеров героев",
    "videoConsiderScaleHintAfter": " (при двух и более героях).",
    "videoConsiderScaleDisabled": "Нужны хотя бы два героя в шоте.",
    "videoConsiderScaleFiguresIncomplete": "У некоторых объектов нет изображения для листа размеров - они не войдут в него.",
    "videoConsiderPropScale": "Учитывать масштаб предметов",
    "videoConsiderPropScaleHintBefore": "Прикрепить ",
    "videoConsiderPropScaleHintLink": "лист размеров предметов",
    "videoConsiderPropScaleHintAfter": " (при двух и более предметах с размером).",
    "videoConsiderPropScaleDisabled": "Нужны хотя бы два предмета с заданным размером по диагонали в шоте.",
    "videoConsiderMixedScale": "Учитывать масштаб",
    "videoConsiderMixedScaleHintBefore": "Прикрепить ",
    "videoConsiderMixedScaleHintBeforeCompact": "Прикрепить ",
    "videoConsiderMixedScaleHintLink": "общий лист размеров",
    "videoConsiderMixedScaleHintAfter": " (герои и предметы на одной линейке).",
    "mixedScaleSheetTitle": "Лист размеров",
    "mixedScaleSheetLoadError": "Не удалось загрузить общий лист размеров",
    "mixedScaleSheetNeedTwo": "Нужен хотя бы один герой и один предмет с заданным размером.",
    "mixedScaleSheetApplyAll": "Применить все",
    "mixedScaleSheetHeightLabel": "Размер",
    "mixedScaleSheetRegenerateScalePose": "Перегенерировать A-pose",
    "mixedScaleSheetRegenerateFrontView": "Перегенерировать вид спереди",
    "mixedScaleSheetScalePoseRequired": "Сначала сгенерируйте лист героя или лист референса",
    "shootingBoardSeedanceOnly": "Доступно только при движке видео Seedance (провайдер OpenRouter / BytePlus Seedance). Текущий провайдер не передаёт раскадровку в генерацию.",
    "shootingBoardReferenceHint": "Изображение раскадровки уходит в референсы Seedance; в промпт добавляется указание следовать порядку панелей и кадрам.",
    "seedanceAdaptiveDuration": "Авто-длительность (по видео-референсу)",
    "seedanceAdaptiveDurationHint": "Отправляет duration -1 / adaptive ratio: выход следует за входным видео (editing-задачи Seedance 2.x). Действует, только когда генерация уходит с видео-референсом — клипом аниматика или кастомным видео.",
    "noShootingBoard": "Нет раскадровки у шота — сначала сгенерируйте или загрузите её.",
    "originalSeed": "Оригинальный seed: {{id}}",
    "originalShort": "Оригинал: {{id}}",
    "originalSeedLabel": "Оригинальный:",
    "originalSeedHint": "По умолчанию используется оригинальный seed шота. Один и тот же seed будет отправляться для всех версий этого шота, пока вы его не измените.",
    "seedOverrideHint": "Сейчас задан override; чтобы вернуться к оригинальному seed, укажите {{seed}}.",
    "seedMustBeInteger": "Seed должен быть целым числом.",
    "transcribe": "Расшифровать",
    "transcriptionSegmentHint": "Расшифровка сегмента аниматика, привязанного к шоту.",
    "pickCamera": "Выбрать камеру",
    "clearCamera": "Убрать камеру",
    "cameraPresets": "Пресеты камеры",
    "cameraPresetsChanged": "(изменено)",
    "cameraPresetsHint": "Выбранные пресеты передаются в системный промпт при генерации.",
    "promptsTitle": "Промпты",
    "promptsTitleFrame": "Промпты кадра",
    "promptsTitleWithShot": "Промпты · шот {{number}}",
    "approxDurationSec": "≈ {{seconds}} с",
    "emptyOverridesHint": "Пустые переопределения = автосборка на сервере.",
    "frameTab": "Кадр",
    "videoTab": "Видео",
    "referencesToApi": "Референсы → API",
    "storyboardToApi": "Опорный кадр → API",
    "requestText": "Текст запроса",
    "artifactReady": "Артефакт готов.",
    "trimmingInProgress": "Нарезка выполняется…",
    "trimFailed": "Нарезка не удалась — проверьте сегмент {{min}}–{{max}} с и сохраните снова. Для аудио-режимов нужен исходник со звуковой дорожкой.",
    "trimQueued": "После сохранения будет поставлена задача нарезки.",
    "loadError": "Ошибка загрузки",
    "loadSettingsError": "Ошибка сохранения настроек",
    "saveSeedError": "Ошибка сохранения seed",
    "transcriptionStartFailed": "Не удалось запустить расшифровку",
    "uploadAnimaticButton": "Загрузить аниматик",
    "uploadingAnimatic": "Загрузка… {{percent}}%",
    "replaceAnimatic": "Заменить аниматик",
    "replaceAnimaticTitle": "Заменить аниматик шота?",
    "replaceAnimaticMessage": "Текущий аниматик открепится от шота, вместо него встанет новый. Файлы не удаляются — прежние аниматики остаются в библиотеке.",
    "replaceAnimaticConfirm": "Заменить",
    "preparingAnimatic": "Готовим аниматик…"
  },
  "animaticRef": {
    "videoSilentTitle": "Видео без звука (основной)",
    "videoSilentDesc": "Немой MP4 как reference_video. Самый совместимый вариант.",
    "downloadMp4": "Скачать MP4",
    "videoWithAudioTitle": "Видео со звуком",
    "videoWithAudioDesc": "Немой MP4 + MP3 как reference_audio — для липсинка и ритма. Звук в ролике задаётся галочкой в настройках проекта.",
    "downloadMp4WithAudio": "Скачать MP4 со звуком (для предпросмотра)",
    "videoWithAudioExtra": "Для предпросмотра в студии; в ARK уходит немой клип + отдельный MP3.",
    "audioOnlyTitle": "Только звук",
    "audioOnlyDesc": "MP3 как reference_audio для липсинка и ритма; визуал — сториборд и обычные референс-изображения. Звук в ролике задаётся галочкой в настройках проекта.",
    "downloadMp3": "Скачать MP3"
  },
  "placeholders": {
    "framePrompt": "Опишите кадр. Введите @ для героев, локаций, реквизита и референсов.",
    "videoPrompt": "Опишите движение и действие. Введите @ для героев, локаций, реквизита и референсов.",
    "shootingBoardPrompt": "Опишите раскадровку. Введите @ для героев, локаций, реквизита и референсов.",
    "intentSummary": "Опишите, что происходит в кадре…",
    "correctionFrame": "Например: сделай небо более пасмурным, добавь тени от деревьев…",
    "correctionVideo": "Например: убрать дрожание камеры в конце, сделать небо чуть темнее…",
    "correctionFrameLong": "Например: сделай небо более пасмурным, добавь тени от деревьев, измени освещение на вечернее...",
    "correctionVideoLong": "Например: убрать дрожание камеры в конце, сделать небо чуть темнее, исправить артефакт на руке…",
    "improveInstructions": "Например: усиль драматичность освещения, добавь больше деталей в одежду, сократи текст до 3 предложений…",
    "searchNameRole": "Поиск по имени / роли…",
    "searchNameCategory": "Поиск по названию / категории…",
    "searchLocation": "Поиск локации…",
    "searchByName": "Поиск по названию…",
    "newCharacterName": "Имя нового героя",
    "newPropName": "Название нового реквизита",
    "generationId": "generation_id из OpenRouter"
  },
  "edit": {
    "title": "Шот {{label}}",
    "descriptionLabel": "Описание шота",
    "sceneLabel": "Сцена",
    "sceneHint": "Шот станет последним в выбранной сцене и получит новый номер.",
    "sceneSearchPlaceholder": "Поиск сцены…",
    "movedToast": "Шот перенесён: {{label}}",
    "moveFailed": "Не удалось перенести шот",
    "toggleVisibilityFailed": "Не удалось изменить видимость ({{status}})",
    "deleteFailed": "Не удалось удалить шот ({{status}})"
  },
  "improvePrompt": {
    "titleStoryboard": "Улучшение промпта кадра",
    "titleVideo": "Улучшение промпта видео",
    "description": "Укажите, как именно улучшить промпт. Пустое поле — стандартное улучшение по правилам модели.",
    "instructionsLabel": "Дополнительные указания",
    "includeTranscription": "Учитывать расшифровку аниматика",
    "transcriptionUnavailable": "Для этого шота расшифровка недоступна — блок не попадёт в запрос.",
    "transcriptionHint": "Расшифровка передаётся в system_prompt как контекст сцены (реплики, действия, тайминги)."
  },
  "promptVersions": {
    "titleStoryboard": "История промптов кадра",
    "titleVideo": "История промптов видео",
    "loading": "Загрузка…",
    "empty": "Версий пока нет. Сохраните промпт, чтобы зафиксировать версию.",
    "source": {
      "manual": "Сохранено",
      "improver": "Улучшение",
      "default": "По умолчанию",
      "generation": "Генерация"
    },
    "active": "Активная",
    "insertIntoField": "Подставить в поле",
    "makeActive": "Сделать активной",
    "doubleClickActivate": "Двойной клик — сделать активной"
  },
  "mediaVersionPrompt": {
    "title": "Промпт версии",
    "promptLabel": "Промпт",
    "makeActive": "Сделать активным"
  },
  "characters": {
    "title": "Герои",
    "dialogTitle": "Герои кадра {{label}}",
    "dialogDescription": "Выберите участников шота и при необходимости конкретный образ. Герой, отсутствующий в касте сцены, добавится автоматически при сохранении.",
    "hint": "Отметьте героев, которые есть в кадре.",
    "noPeople": "Кадр без людей",
    "noPeopleHint": "Промпт сториборда и видео получат запрет на людей; референсы героев не будут отправлены в генерацию.",
    "noMatching": "В проекте нет подходящих персонажей. Добавьте нового ниже.",
    "useVoice": "Использовать голос",
    "includeDescription": "Описание в промпт",
    "useVoiceNotReady": "У героя нет готового активного голоса. Настройте голос в карточке героя.",
    "useVoiceProviderUnsupported": "Голосовые референсы поддерживает только видеогенерация Seedance.",
    "useVoiceLimit": "Достигнут лимит: не больше {{max}} голосовых референсов на шот (ограничение Seedance).",
    "quickAdd": "Быстрое добавление героя",
    "add": "Добавить",
    "defaultOutfit": "Базовый образ",
    "charactersSection": "Герои шота",
    "recognized": "({{count}} распознано)",
    "noCharacters": "Нет персонажей.",
    "openImage": "Открыть изображение «{{name}}»",
    "charactersLink": "Раздел «Герои»"
  },
  "props": {
    "title": "Реквизит",
    "hint": "Отметьте реквизит, который есть в кадре.",
    "noMatching": "В проекте нет подходящего реквизита. Добавьте новый ниже.",
    "quickAdd": "Быстрое добавление реквизита",
    "add": "Добавить",
    "baseState": "Базовое состояние",
    "openImage": "Открыть изображение «{{name}}»"
  },
  "location": {
    "title": "Локация",
    "dialogTitle": "Локация кадра {{label}}",
    "dialogDescription": "Выберите локацию, вариант и ракурс референса. Один кадр — одна локация.",
    "hint": "Выберите локацию и ракурс для кадра.",
    "saved": "Локация сохранена",
    "saveFailed": "Не удалось сохранить локацию",
    "loadError": "Ошибка загрузки",
    "noLocations": "В проекте нет локаций.",
    "nothingFound": "Ничего не найдено.",
    "facingSection": "Сторона света (референс)",
    "facingGroup": "Сторона света",
    "facingWithRef": "{{name}} · есть референс",
    "facingNoRef": "{{name}} · нет референса",
    "facingLoaded": "{{name}}, референс загружен",
    "facingMissing": "{{name}}, референса нет",
    "facingHint": "Ракурс задаётся после выбора локации и варианта. Если базового вида нет — показывается 3/4. Без локации на сервере используется север.",
    "angles": {
      "basic": "Базовые ракурсы",
      "photographed": "Дополнительные ракурсы"
    },
    "saveAsPrimaryFacing": "Новая локация сохранится как основной референс 3/4.",
    "openLocationImage": "Открыть изображение локации «{{name}}»",
    "openImage": "Открыть изображение «{{name}}»",
    "noLocation": "Без локации",
    "locationsLink": "Раздел «Локации»",
    "recognized": "(распознана: {{name}})",
    "shotLocation": "Локация шота",
    "facing": {
      "three_quarter": "Три четверти",
      "topview": "Вид сверху",
      "north": "Север",
      "east": "Восток",
      "south": "Юг",
      "west": "Запад",
      "short": {
        "three_quarter": "3/4",
        "topview": "Сверху"
      },
      "letter": {
        "north": "С",
        "east": "В",
        "south": "Ю",
        "west": "З"
      }
    }
  },
  "correction": {
    "frameTitle": "Корректировка кадра",
    "videoTitle": "Корректировка",
    "frameDescription": "Опишите что нужно изменить — на основе текущего кадра будет сгенерирована новая версия.",
    "videoDescription": "Опишите что нужно изменить — на основе текущего видео будет сгенерирована новая версия. Указывайте интервалы в секундах (например 0–2 с, с 3 с до конца).",
    "whatToChange": "Что изменить в видео",
    "startCorrection": "Запустить корректировку",
    "startFailed": "Не удалось запустить корректировку.",
    "correctFailed": "Не удалось скорректировать кадр.",
    "queueFailed": "Не удалось поставить корректировку в очередь.",
    "loadingVersions": "Загрузка версий…",
    "noVideoVersion": "Нет версии видео для корректировки.",
    "correctionSource": "Источник коррекции",
    "active": "Активная",
    "clipForCorrection": "Клип для коррекции",
    "noPreviewUrl": "Нет URL превью",
    "versionFrames": "Первый и последний кадр версии",
    "framesNotExtracted": "Кадры не извлечены для этой версии",
    "firstFrameUnavailable": "Первый кадр недоступен",
    "lastFrameUnavailable": "Последний кадр недоступен",
    "timelineMarkers": "Метки на таймлайне",
    "markups": "Пометки на кадре",
    "addMarkup": "Сохранить пометку",
    "markupCap": "{{count}} / {{max}}",
    "markupMentionHint": "Введите @ чтобы упомянуть пометку по таймкоду",
    "captureUnavailable": "Для сохранения пометки нужна локальная копия видео этой версии."
  },
  "preview": {
    "loadFailed": "Не удалось загрузить данные шота.",
    "uploadShootingBoardFailed": "Не удалось загрузить раскадровку.",
    "uploadFrameFailed": "Не удалось загрузить кадр.",
    "uploadVideoFailed": "Не удалось загрузить видео.",
    "videoTransitionNotGenerated": "Видео-переход ещё не сгенерирован.",
    "videoNotGenerated": "Видео ещё не сгенерировано.",
    "transitionFramesNotReady": "Кадры перехода ещё не готовы.",
    "storyboardNotGenerated": "Опорный кадр ещё не сгенерирован.",
    "shootingBoardNotCreated": "Раскадровка ещё не создана.",
    "storyboardFromPrevShot": "Кадр из шота {{label}}",
    "storyboardFromPrevShotHint": "Заменит опорный кадр на последний кадр видео шота {{label}}",
    "storyboardFromPrevShotFailed": "Не удалось обновить опорный кадр.",
    "storyboardFromLibrary": "Из библиотеки",
    "storyboardFromLibraryHint": "Выбрать опорный кадр из библиотеки кадров",
    "storyboardFromLibraryFailed": "Не удалось установить кадр из библиотеки.",
    "shootingBoardFromLibrary": "Из библиотеки",
    "shootingBoardFromLibraryHint": "Выбрать раскадровку из библиотеки кадров",
    "shootingBoardFromLibraryFailed": "Не удалось установить раскадровку из библиотеки.",
    "videoFromLibrary": "Из библиотеки",
    "videoFromLibraryHint": "Выбрать видео из библиотеки",
    "videoFromLibraryFailed": "Не удалось установить видео из библиотеки.",
    "pickFromLibrary": "Выбрать из библиотеки",
    "leftShotLastFrame": "Последний кадр левого шота",
    "rightShotFirstFrame": "Первый кадр правого шота"
  },
  "transcription": {
    "title": "Расшифровка сегмента",
    "loadFailed": "Не удалось загрузить данные",
    "approveFailed": "Ошибка при утверждении",
    "networkError": "Ошибка сети",
    "notDone": "Расшифровка для этого шота ещё не выполнена. Запустите расшифровку сегмента аниматика, привязанного к этому шоту.",
    "environment": "Окружение",
    "lighting": "Свет: {{value}}",
    "charactersFromVideo": "Персонажи из видео",
    "dialogues": "Диалоги",
    "editablePrompts": "Промпты (редактируемые)",
    "firstFramePrompt": "Промпт первого кадра",
    "videoPrompt": "Промпт видео",
    "approved": "Утверждено — герои, локация и промпты обновлены.",
    "apply": "Применить героев, локацию и промпты",
    "noLocations": "Нет локаций."
  },
  "references": {
    "openOriginal": "Открыть оригинал",
    "openCharacters": "Открыть героев",
    "openProps": "Открыть реквизит",
    "openLocation": "Открыть локацию",
    "characters": "Герои",
    "props": "Реквизит",
    "location": "Локация",
    "scene3d": "3D-сцена",
    "openScene3d": "Открыть 3D-сцену",
    "kindCharacter": "герой",
    "kindProp": "реквизит",
    "kindLocation": "локация",
    "appearanceUpdated": "Лист героя обновлён после последней генерации — шот стоит перегенерировать",
    "propAppearanceUpdated": "Картинка предмета обновилась после последней генерации — шот стоит перегенерировать"
  },
  "referenceInputs": {
    "title": "Свои референсы шота",
    "addToPrompt": "Добавить в промпт",
    "removeConfirm": "Удалить референс {{label}}?",
    "removeConfirmUsed": "В промпте встречается {{label}}. Удалить референс всё равно? Номер не переиспользуется — при необходимости поправьте текст промпта.",
    "sendStoryboardFrame": "Отправлять опорный кадр в API",
    "skipStoryboardFrame": "Не отправлять опорный кадр в API",
    "voiceReferenceTitle": "Голос героя {{name}}",
    "addFromLibrary": "Из библиотеки",
    "attach": "Прикрепить",
    "addFromLibraryFailed": "Не удалось добавить референс из библиотеки.",
    "addFromLibraryPartial": "Не удалось добавить: {{names}}"
  },
  "mediaVersions": {
    "storyboard": "Версии кадров",
    "storyboardModal": "Версии сториборда",
    "shooting_board": "Раскадровка",
    "shooting_boardModal": "Версии раскадровки",
    "video": "Версии видео",
    "loadFailed": "Не удалось загрузить версии.",
    "activateFailed": "Не удалось активировать версию.",
    "qualitySaveFailed": "Не удалось сохранить метку.",
    "uploadFrameFailed": "Не удалось загрузить кадр.",
    "uploadShootingBoardFailed": "Не удалось загрузить раскадровку.",
    "uploadVideoFailed": "Не удалось загрузить видео.",
    "noShotInResponse": "Ответ сервера без данных шота",
    "modalSubtitle": "Шот {{scene}}.{{number}} — выберите активную версию для страницы workspace.",
    "doubleClickHint": "Двойной клик по версии — сделать текущей.",
    "backToVersions": "Назад к версиям",
    "apiRequest": "Запрос к API",
    "provider": "Провайдер",
    "model": "Модель",
    "endpoint": "Endpoint",
    "status": "Статус",
    "time": "Время",
    "date": "Дата",
    "error": "Ошибка",
    "checkGeneration": "Проверить генерацию",
    "checkGenerationHint": "Если в OpenRouter Dashboard генерация завершена успешно, вставьте её ID и нажмите «Проверить». Изображение будет загружено и сохранено как сториборд-кадр.",
    "check": "Проверить",
    "enterGenerationId": "Введите generation_id.",
    "imageSaved": "Изображение сохранено.",
    "imageNotFound": "Изображение не найдено.",
    "noPreview": "Нет превью",
    "current": "Текущая",
    "apiRequestTitle": "Запрос к API",
    "versionPrompt": "Промпт версии",
    "promptNotSaved": "Промпт не сохранён для этой версии (только для новых генераций)",
    "makeCurrent": "Сделать текущей",
    "makeCurrentEllipsis": "…",
    "previewTitle": "{{name}}",
    "doubleClickActivate": "Двойной клик — сделать текущей",
    "empty": "Пока нет сохранённых версий.",
    "fromVideoPrompt": "Из промпта видео",
    "fromVideoPromptTitle": "Генерация из текста видео-промпта (провайдер изображений проекта)",
    "copyOriginalToClipboard": "Копировать оригинал в буфер обмена",
    "logStatus": {
      "pending": "Готовится",
      "sent": "Отправлен",
      "succeeded": "Успешно",
      "failed": "Ошибка",
      "abandoned": "Брошен",
      "cancelled": "Отменён"
    }
  },
  "details": {
    "title": "Шот {{number}}",
    "titleFallback": "Кадр",
    "description": "Все сохранённые поля шота и сырой JSON из LLM. Чтобы обновить промпты из n8n, перегенерируйте шоты сцены или все шоты проекта — записи шотов при этом сохраняют id.",
    "projectTree": "Контекст в дереве проекта",
    "season": "Сезон {{number}}",
    "episode": "Серия {{number}}",
    "scene": "Сцена {{number}}",
    "projectLocation": "Локация в проекте:",
    "idsAndStatus": "Идентификаторы и статус",
    "cameraPreset": "пресет камеры: {{name}}",
    "locationVariant": "вариант локации:",
    "targetDuration": "целевая длительность: {{seconds}}s",
    "charactersBinding": "Персонажи (привязка к шоту)",
    "intentSummary": "Назначение кадра (intent_summary)",
    "notSet": "не задано",
    "userVisiblePrompt": "Промпт для кадра (user_visible_prompt_summary)",
    "llmFieldsGlue": "Склейка по полям LLM (description, visual_details, camera…)",
    "storyboardVideo": "Storyboard / видео (URL и промпты)",
    "storyboardPreview": "превью storyboard:",
    "none": "нет",
    "clip": "клип:",
    "systemPromptOverride": "Системный промпт (override / default)",
    "overrideEmptyDefault": "override пуст — на странице storyboard подставится default.",
    "defaultSystem": "Default системный",
    "klingPromptOverride": "Промпт кадра Kling (override / default)",
    "overrideEmptyAuto": "override пуст — подставится автосборка.",
    "defaultFramePrompt": "Default промпт кадра",
    "llmExtras": "llm_extras (сырой JSON)",
    "empty": "пусто"
  },
  "promptEditor": {
    "defaultAriaLabel": "Промпт",
    "wrapSegmentTitle": "Обернуть текущую строку в сабшот",
    "segment": "+сегмент",
    "mentionHint": "Введите @ для героев, локаций, реквизита и референсов",
    "blockTimecode": "Таймкод блока",
    "removeBlock": "Убрать блок",
    "segmentCamera": "Камера не выбрана",
    "pickSegmentCamera": "Выбрать камеру для этого сегмента",
    "clearSegmentCamera": "Убрать камеру сегмента",
    "pinnedGroup": "Привязаны к шоту",
    "category": {
      "hero": "Герои",
      "loc": "Локации",
      "prop": "Реквизит",
      "shot": "Шоты",
      "reference": "Референсы",
      "cam": "Камеры",
      "attr": "Характеристики",
      "file": "Файлы",
      "person": "Люди",
      "task": "Задачи",
      "script": "Сценарий",
      "node": "Ноды",
      "img": "Изображения",
      "vid": "Видео"
    },
    "nothingFound": "Ничего не найдено",
    "propBase": "базовый",
    "videoMedia": "видео",
    "audioMedia": "аудио",
    "mention": {
      "remove": "Удалить",
      "replace": "Заменить",
      "open": "Открыть",
      "missingFile": "@файл удалён"
    }
  },
  "postProduction": {
    "action": "Обработка",
    "launchTitle": "Обработка",
    "launchDescription": "Выберите модель обработки, настройте параметры и создайте производную версию видео.",
    "loadingModels": "Загрузка моделей обработки…",
    "loadModelsFailed": "Не удалось загрузить модели обработки",
    "loadVersionsFailed": "Не удалось загрузить версии обработки",
    "startFailed": "Не удалось запустить обработку",
    "actionFailed": "Не удалось выполнить действие обработки",
    "noSource": "Сначала выберите или сгенерируйте версию видео.",
    "noModels": "Нет активных моделей обработки.",
    "version": "Версия",
    "noVersion": "Нет версии",
    "parameters": "Параметры",
    "noParameters": "У этой модели нет настраиваемых параметров.",
    "parameterLabels": {
      "upscale_factor": "Масштаб"
    },
    "parameterOptions": {
      "upscale_factor": {
        "1": "1×",
        "2": "2×",
        "4": "4×"
      }
    },
    "parameterHint": {
      "decimalBetween": "Число от {{min}} до {{max}}",
      "integerBetween": "Целое число от {{min}} до {{max}}"
    },
    "parameterValidation": {
      "required": "Параметр обязателен.",
      "invalid": "Некорректное значение.",
      "invalidEnum": "Выберите одно из допустимых значений.",
      "mustBeInteger": "Должно быть целым числом.",
      "mustBeNumber": "Должно быть числом.",
      "belowMinimum": "Не меньше {{min}}.",
      "aboveMaximum": "Не больше {{max}}.",
      "belowMinLength": "Не меньше {{min}} символов.",
      "aboveMaxLength": "Не больше {{max}} символов.",
      "patternMismatch": "Значение не соответствует нужному формату."
    },
    "defaultParameter": "По умолчанию",
    "enabledParameter": "Включено",
    "unsupportedParameterType": "Неподдерживаемый тип: {{type}}",
    "sourceVersion": "Исходная версия видео #{{id}}",
    "start": "Запустить обработку",
    "largeOutputConfirm": {
      "title": "Видео больше 4K",
      "message": "Вы собираетесь получить видео примерно {{width}}×{{height}}. Это очень большой файл и дорогая генерация. Продолжить?",
      "confirm": "Всё равно запустить"
    },
    "queued": "Обработка поставлена в очередь",
    "panelTitle": "Версии обработок",
    "panelHint": "Производные видео для выбранной версии шота.",
    "panelHintWithSource": "Производные видео от версии #{{id}}.",
    "empty": "Для этого источника пока нет версий обработки.",
    "reset": "Использовать исходное видео",
    "original": "Оригинал",
    "originalHint": "Исходное видео без обработки",
    "current": "Текущая",
    "use": "Использовать",
    "doubleClickUse": "Дважды кликните результат, чтобы сделать его текущим видео шота.",
    "deleteConfirm": "Удалить эту версию обработки?",
    "status": {
      "queued": "В очереди",
      "processing": "Обработка",
      "done": "Готово",
      "failed": "Ошибка"
    }
  },
  "frameCaptures": {
    "title": "Скриншоты",
    "captureHint": "Снять кадр в текущей позиции",
    "captureFailed": "Не удалось снять кадр.",
    "deleteConfirm": "Удалить скриншот?",
    "deleteFailed": "Не удалось удалить скриншот.",
    "delete": "Удалить скриншот",
    "failed": "Ошибка"
  },
  "apiErrors": {
    "loadShotFailed": "Не удалось загрузить данные шота ({{status}})",
    "saveFailed": "Сохранение не удалось ({{status}})",
    "noShotInResponse": "Ответ сервера без данных шота",
    "loadStoryFailed": "Не удалось загрузить текст истории ({{status}})",
    "loadCastFailed": "Не удалось загрузить каст ({{status}})",
    "loadPropsFailed": "Не удалось загрузить реквизит ({{status}})",
    "loadLocationsFailed": "Не удалось загрузить локации ({{status}})",
    "linkSegmentFailed": "Не удалось привязать сегмент ({{status}})",
    "loadSiblingsFailed": "Не удалось загрузить соседние шоты ({{status}})",
    "loadPromptVersionsFailed": "Не удалось загрузить версии промпта ({{status}})",
    "loadMediaVersionsFailed": "Не удалось загрузить версии ({{status}})",
    "activatePromptVersionFailed": "Не удалось активировать версию промпта ({{status}})",
    "improvePromptFailed": "Не удалось улучшить промпт ({{status}})",
    "unlinkSegmentFailed": "Не удалось отвязать сегмент ({{status}})",
    "loadTranscriptionsFailed": "Не удалось загрузить расшифровки ({{status}})",
    "activateTranscriptionFailed": "Не удалось активировать расшифровку ({{status}})",
    "uploadAnimaticFailed": "Не удалось загрузить аниматик ({{status}})"
  },
  "frameLibrary": {
    "assignStoryboard": "Сделать опорным кадром",
    "assignShootingBoard": "Сделать раскадровкой",
    "assignVideo": "Сделать видео шота",
    "subtitleStoryboard": "Опорный кадр · Шот {{number}}",
    "subtitleShootingBoard": "Раскадровка · Шот {{number}}",
    "subtitleVideo": "Видео · Шот {{number}}",
    "subtitleAnimatic": "Аниматик · Шот {{number}}",
    "subtitlePreviz": "Превиз · Шот {{number}}"
  },
  "transitionFrames": {
    "manual": "вручную",
    "pick": "Выбрать кадр",
    "reset": "Авто",
    "resetHint": "Вернуть кадр соседнего шота",
    "assignLeft": "Поставить левым кадром",
    "assignRight": "Поставить правым кадром",
    "subtitleLeft": "Левый кадр перехода · Шот {{number}}",
    "subtitleRight": "Правый кадр перехода · Шот {{number}}",
    "assignFailed": "Не удалось назначить кадр перехода.",
    "resetFailed": "Не удалось вернуть автоматический кадр."
  },
  "assetShelf": {
    "versionLabel": "v{{n}}",
    "makeActive": "Сделать основной: v{{n}} · {{date}}",
    "activeVersion": "Основная версия v{{n}}",
    "generatingVersionN": "Генерируется v{{n}} · {{progress}}%",
    "allVersions": "Все версии ({{count}})",
    "references": "Референсы",
    "referencesCount": "Референсы: {{count}}",
    "refsTitleVideo": "Что уйдёт в генерацию видео",
    "refsTitleFrame": "Что уйдёт в генерацию кадра",
    "previz": "Превиз",
    "animatic": "Аниматик",
    "none": "Нет",
    "original": "Оригинал",
    "depthGray": "Глубина ч/б",
    "depthColor": "Глубина цв.",
    "animSilent": "Без звука",
    "animWithAudio": "Со звуком",
    "animAudioOnly": "Только звук",
    "currentFrame": "Текущий кадр как референс",
    "currentFrameHint": "Правка поверх того, что уже есть",
    "animaticFrame": "Кадр из аниматика",
    "animaticFrameHint": "Только композиция: ч/б скетч",
    "motionExclusiveHint": "Превиз и аниматик ведут камеру одним видео-референсом — выбирается один.",
    "savedOnGenerate": "Сохранится вместе с промптом при запуске.",
    "noPreviz": "К шоту не привязан превиз",
    "noAnimatic": "Шот не привязан к аниматику",
    "depthNotReady": "Сначала посчитайте маску глубины на вкладке «Превиз»",
    "previzTooLong": "Превиз длиннее лимита видео-референса",
    "summaryPreviz": "превиз",
    "summaryDepth": "глубина",
    "summaryAnimatic": "аниматик",
    "summaryCurrent": "текущий кадр",
    "sendToVideo": "В видео отправлять",
    "postProductionApplied": "Обработанная версия",
    "currentVideo": "Текущее видео как референс",
    "currentVideoHint": "Движение, тайминг и постановка прошлого дубля",
    "noCurrentVideo": "У шота ещё нет видео",
    "summaryCurrentVideo": "текущее видео",
    "motionExclusiveHintWithVideo": "Текущее видео, превиз и аниматик ведут движение одним видео-референсом — выбирается один.",
    "ctxStoryboardFrame": "Опорный кадр",
    "ctxStoryboardFrameName": "первый кадр видео",
    "ctxOwnRefs": "Свои референсы",
    "ctxHeroes": "Герои",
    "ctxProps": "Реквизит",
    "ctxLocation": "Локация",
    "generateDepth": "Сгенерировать маску глубины",
    "changeFrameModel": "Сменить модель кадра",
    "modelSearch": "Найти модель",
    "modelFromProject": "Как в проекте",
    "modelNothingFound": "Ничего не найдено",
    "modelOverriddenHint": "Своя модель шота. В проекте — {{project}}",
    "audio": "Звук в видео",
    "audioOnHint": "Видео сгенерируется со звуком. Нажмите, чтобы без звука.",
    "audioOffHint": "Видео сгенерируется без звука. Нажмите, чтобы со звуком.",
    "audioDiffersHint": "Своя настройка шота, в проекте — наоборот."
  }
}
